export { default } from './DotSlideIndicator';
